import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {formatDateNow} from "../i18n/date-formatting";
import {deliveryTimelineStatus, isDeliveryTimelineEvent, timelineDescriptionLabel} from "./delivery-progress";
import DeliveryProgressChip from "./delivery-progress-chip";

export default function DeliveryTimeline({events = []}) {
    const {t, i18n} = useTranslation();
    const deliveryEvents = events.filter(isDeliveryTimelineEvent)
        .sort((left, right) => new Date(left.date) - new Date(right.date));
    if (!deliveryEvents.length) return null;
    return <Box sx={{mt: 2}}>
        <Typography variant="subtitle2" gutterBottom>{t("CourierDeliveryTimeline")}</Typography>
        <Stack component="ol" spacing={1} sx={{pl: 3}}>
            {deliveryEvents.map((event, index) => <Box component="li" key={`${event.date}:${event.status}:${index}`}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{flexWrap: "wrap", gap: 1}}>
                    <DeliveryProgressChip status={deliveryTimelineStatus(event)}/>
                    <Typography variant="caption" color="text.secondary">{formatDateNow(event.date, i18n.language, true)}</Typography>
                </Stack>
                <Typography variant="body2" sx={{mt: 0.5}}>{t(event.description === "CourierAssigned"
                    ? "CourierAssignedToOrder" : timelineDescriptionLabel(event))}</Typography>
            </Box>)}
        </Stack>
    </Box>;
}
